// Central role → capability map for the tailored Employee experience.
// NOTE: This governs UI navigation/visibility only. Backend authorization
// remains the final security authority; this never grants access on its own.

export const STAFF_ROLES = [
  "admin",
  "super_admin",
  "compliance_director",
  "senior_verification_manager",
  "security_admin",
];

export const isStaff = (role) => STAFF_ROLES.includes(role);

// Admin Control Center tabs each role may see (super_admin sees all).
export const ADMIN_TABS_BY_ROLE = {
  super_admin: ["Overview", "Users", "Subscriptions", "Onboarding", "Compliance", "Approval Queue", "Verifications", "Trust Scores"],
  compliance_director: ["Overview", "Onboarding", "Compliance", "Approval Queue", "Verifications", "Trust Scores"],
  senior_verification_manager: ["Overview", "Approval Queue", "Verifications"],
  admin: ["Overview", "Onboarding", "Compliance", "Trust Scores"],
  // security_admin intentionally has NO Admin Control Center access
};

export const adminTabsFor = (role) => ADMIN_TABS_BY_ROLE[role] || [];
export const canSeeAdminCenter = (role) => (ADMIN_TABS_BY_ROLE[role] || []).length > 0;

// Console/link visibility (mirrors backend route guards).
export const canSeeSecurityDashboard = (role) => ["super_admin", "compliance_director"].includes(role);
export const canSeeSystemIntelligence = (role) => ["super_admin", "compliance_director", "security_admin"].includes(role);
export const canSeeIncidentResponse = (role) => ["super_admin", "compliance_director", "security_admin"].includes(role);
export const canSeeDemandGaps = (role) => ["admin", "super_admin", "compliance_director"].includes(role);
export const canSeeLeadGeneration = (role) => ["admin", "super_admin", "compliance_director"].includes(role);
export const canSeeBetaReport = (role) => ["admin", "super_admin", "compliance_director"].includes(role);
export const canSeeReviewerWorkload = (role) => ["super_admin", "compliance_director", "senior_verification_manager"].includes(role);
export const canSeePreviewTools = (role) =>
  role === "super_admin" && process.env.REACT_APP_PREVIEW_TOOLS === "true";

// Short human label for the role, shown in the staff workspace header.
export const ROLE_LABEL = {
  super_admin: "Super Admin",
  admin: "Employee — Operations",
  compliance_director: "Employee — Compliance Director",
  senior_verification_manager: "Employee — Verification Manager",
  security_admin: "Employee — Security",
  user: "Member",
};
export const roleLabel = (role) => ROLE_LABEL[role] || "Member";
